export const ApiEndpoints = {
  autor: {
    authorList: "api/authors",
    authorCreate: "api/author/store",
    authorEdit: "api/author/edit/",
    authorUpdate: "api/author/update",
    authorDelete: "api/author/delete",
  },

  tags: {
    tagList: "api/tags",
    tagCreate: "api/tag/store",
    tagEdit: "api/tag/edit/",
    tagUpdate: "api/tag/update",
    tagDelete: "api/tag/delete",
  },

  adminBlogs: {
    blogList: "api/blogs",
    blogCreate: "api/blogs/store",
    blogEdit: "api/blog/edit/",
    blogUpdate: "api/blog/update/",
    blogDelete: "api/blog/delete",
  },

  dynamicPage: {
    List: "api/dynamicpages",
    Create: "api/dynamicpage/store",
    Edit: "api/dynamicpage/edit/",
    Update: "api/dynamicpage/update/",
    Delete: "api/dynamicpage/delete",
  },

  category: {
    categoryList: "api/blog-categories",
    categoryCreate: "api/blog-category/store",
    categoryEdit: "api/blog-category/edit/",
    categoryUpdate: "api/blog-category/update",
    categoryDelete: "api/blog-category/delete",
  },

  contact: {
    contactCreate: "api/contact/store",
    contactList: "api/contact/view", 
  },

  schedulevisit: {
    scheduleCreate: "api/schedule-visit/store",
    scheduleList: "api/schedule-visits", 
  },

  career: {
    careerCreate: "api/career/store",
    careerList: "api/careers", 
  },
  applynow: {
    applyCreate: "api/apply-now/store",
    applyList: "api/apply-now", 
  },

  seo: {
    seoList: "api/seo",
    seoCreate: "api/seo/store",
    seoEdit: "api/seo/edit/",
    seoUpdate: "api/seo/update",
    seoDelete: "api/seo/delete",
    seoByUrl: 'api/seo-by-url'
  },

  faq: {
    faqList: "api/faqs",
    faqCreate: "api/faq/store",
    faqEdit: "api/faq/edit/",
    faqUpdate: "api/faq/update",
    faqDelete: "api/faq/delete",
    faqByUrl: "api/faq-by-url",
  },

  sitemap: {
    view: "api/sitemap",
    update: "api/sitemap/update",
  },

  schemaManagement: {
    view: "api/schema-management",
    update: "api/schema-management/update",
  },

  globalSeo: {
    view: "api/global-seo",
    update: "api/global-seo/update",
  },

  llms: {
    view: "api/llms",
    update: "api/llms/update",
  },

  robots: {
    view: "api/robots-txt",
    update: "api/robots-txt/update",
  },

  news: {
    newsList: "api/medias",
    newsCreate: "api/media/store",
    newsEdit: "api/media/edit/",
    newsUpdate: "api/media/update/",
    newsDelete: "api/media/delete",
  },

  branch: {
    branchList: "api/branches",
    branchCreate: "api/branch/store",
    branchEdit: "api/branch/edit/",
    branchUpdate: "api/branch/update",
    branchDelete: "api/branch/delete",
  },

  class: {
    classList: "api/classes",
    classCreate: "api/class/store",
    classEdit: "api/class/edit/",
    classUpdate: "api/class/update",
    classDelete: "api/class/delete",
  },

  feeStructure: {
    feeList: "api/fee-structure",
    feeCreate: "api/fee-structure/store",
    feeEdit: "api/fee-structure/edit/",
    feeUpdate: "api/fee-structure/update",
    feeDelete: "api/fee-structure/delete",
  },
  
  Dashboard:{
    List:"api/leads-count",
    monthlycount:"api/leads-count-filter"
  },

  emailManagement: {
    List: "api/dynamic-emails",
    Create: "api/dynamic-email/store",
    Edit: "api/dynamic-email/edit/",
    Update: "api/dynamic-email/update",
    Delete: "api/dynamic-email/delete",
  },

  rbac: {
    myPermissions: "api/rbac/my-permissions",
    userList: "api/rbac/users",
    userCreate: "api/rbac/user/store",
    userEdit: "api/rbac/user/edit/",
    userUpdate: "api/rbac/user/update/",
    userDelete: "api/rbac/user/delete",
    roleList: "api/rbac/roles",
    roleCreate: "api/rbac/role/store",
    roleEdit: "api/rbac/role/edit/",
    roleUpdate: "api/rbac/role/update/",
    roleDelete: "api/rbac/role/delete",
    permissionList: "api/rbac/permissions",
    permissionCreate: "api/rbac/permission/store",
    permissionEdit: "api/rbac/permission/edit/",
    permissionUpdate: "api/rbac/permission/update/",
    permissionDelete: "api/rbac/permission/delete",
  },

  disclosure: {
    List:          "api/Mandatory_disclosure",
    Edit:          "api/Mandatory_disclosure/edit/",
    Update:        "api/Mandatory_disclosure/update/",
    Delete:        "api/Mandatory_disclosure/delete",
    ByBranchSlug:  "api/Mandatory_disclosure/branch/",
    SaveFirstTab:  "api/Mandatory_disclosure/tab/first",
    UpdateFirstTab:"api/Mandatory_disclosure/",        // usage: UpdateFirstTab + {id}/tab/first
    SaveTab:       "api/Mandatory_disclosure/",        // usage: SaveTab + {id}/tab/{tabName}
    BranchDropdown:"api/branches/dropdown",
  },

};
